<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>

<main id="content" role="main" class="main">
    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w6" class="breadcrumb">
                    <li class="breadcrumb-item"><a routerLink="/{{mainPath}}/Dashboard">{{'home'|translate}}</a></li>
                    <li class="breadcrumb-item"><a routerLink="/Sections" [queryParams]="{'SectionId':SectionIdEnv}">{{'e-service'|translate}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{serviceName}}</li>
                </ol>
            </nav>
        </div>
        <div class="row justify-content-center py-7" style="background:url(/img/bg-green-full.png);">
            <div class="col-md-8 col-12">

                <div class="js-step-form" >

                    <ul id="basicStepFormProgress" *ngIf="!viewApplication"
                        class="js-step-progress step step-sm step-icon-sm step-inline step-item-between mb-7">
                        <li class="step-item" [ngClass]="showStep=='1'?'active focus':null">
                            <a class="step-content-wrapper">
                                <span class="step-icon step-icon-soft-dark">1</span>
                                <div class="step-content">
                                    <span class="step-title">{{'general-info'|translate}}</span>
                                </div>
                            </a>
                        </li>
                        <li class="step-item" [ngClass]="showStep=='2'?'active focus':null">
                            <a class="step-content-wrapper">
                                <span class="step-icon step-icon-soft-dark">2</span>
                                <div class="step-content">
                                    <span class="step-title">{{'apply-form'|translate}}</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <ul id="basicStepFormProgress" *ngIf="viewApplication" 

                         [ngStyle]="{'justify-content':stepsName.length>=1 ? 'center':null}"

                        class="js-step-progress step step-sm step-icon-sm step-inline step-item-between mb-7">
                        
                        <li class="step-item" *ngFor="let item of stepsName;let index=index" [ngClass]="index==currentIndex?'active focus':null">
                            <a class="step-content-wrapper">
                                <span class="step-icon step-icon-soft-dark">{{index+1}}</span>
                                <div class="step-content">
                                    <span class="step-title">{{item}}</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>


                    <div id="basicStepFormContent">
                        <div id="basicStepDetails" class="card" [ngClass]="showStep=='1'?'active':null" [ngStyle]="showStep=='2'? {'display':'none'} :null ">
                            <div >
                                <div class="card-header">
                                    <h3 class="card-title h3">{{serviceName}}</h3>
                                </div>

                                <div class="card-body">
                                    <div class="mb-5">
                                        <span [innerHTML]="serviceCard?.description">
                                            
                                        </span>

                                        <p class="mt-4">
                                            <input type="checkbox" [(ngModel)]="goToStep2Enable" (change)="onCheckboxChange($event)">
                                             {{'confirmation'|translate}}
                                        </p>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <button type="button" class="btn btn-primary" [disabled]="!goToStep2Enable" (click)="goStep2()">
                                            {{'apply'|translate}} </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div id="basicStepTerms" class="card active" [ngStyle]="showStep=='1'? {'display':'none'} :null ">
                            <div >
                                <div class="card-header">
                                    <h3 class="card-title h3">{{serviceName}}</h3>
                                </div>

                                <div class="card-body">

                                    <h4 class="text-center"> {{screenName}} </h4>

                                    <br>
                                    <br>


                                    <div class="alert alert-danger" role="alert" *ngIf="fieldsHasNote.length>0" >
                                        <p *ngFor="let fieldNote of fieldsHasNote">
                                            ◉ {{fieldNote.label}} -   {{fieldNote.comment}}
                                        </p>
                                    </div>

                                    <form id="service-form" [formGroup]="myForm">

                                        <ng-container *ngFor="let field of fields">

                                            <ng-container *ngIf="field.type=='FILE'">

                                                <app-file 
                                                [formGroup]="myForm"
                                                [errors]="getFormControlErrors(field.id)"
                                                [viewApplication]="viewApplication"
                                                [files]="getFiles(field.id)"
                                                [isInvalid]="getFiles(field.id).length==0 && field.required"
                                                [field]="field"
                                                [fieldId]="field.id"
                                                [submitted]="submitted"
                                                [yourTurn]="yourTurn"
                                                [containerFieldId]="undefined"
                                                [fieldIndex]="undefined"
                                                [isContainer]="false"
                                                (refreshFormEvent)="refreshForm($event)"
                                                (deleteFileEvent)="deleteFile($event)"
                                                (onUploadFileEvent)="onUploadFile($event)"
                                                
                                                >
                                            </app-file>

                                
                                            </ng-container>

                                            <ng-container *ngIf="field.type=='URL_LAUNCHER'">

                                                <div class="row mb-4 align-items-center" [hidden]="field.hidden"> 

                                                    <label class="col-sm-2 col-form-label form-label">
                                                        {{field.label}}
                                                        <span class="text-danger" *ngIf="field.required"> * </span>
                                                    </label>

                                                    <div class="col-sm-10" *ngIf="field.value!=null && field.value!=''"> 
                                                        <a href="{{field.url}}" role="button" target="_blank">عرض 
                                                            <i class="fa fa-eye text-primary"></i>
                                                        </a>
                                                    </div>

                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="field.type=='WEBVIEW'">
                                                <div class="row mb-4" [hidden]="field.hidden">

                                                    <div class="col-4">

                                                        <a href="{{appendQueryString(field.url!)}}" target="_blank">
                                                            {{field.label}}
                                                        </a>

                                                    </div>

                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="field.type=='TEXT_VIEW'">

                                                <app-text-view [formGroup]="myForm"
                                                [errors]="getFormControlErrors(field.id)"
                                                [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                [hidden]="field.hidden"
                                                (refreshFormEvent)="refreshForm($event)" [value]="myForm.get(field.id)?.value"></app-text-view>

                                            
                                            </ng-container>

                                            <ng-container *ngIf="field.type=='COPY_WIDGET'">

                                                <div [hidden]="field.hidden">

                                                <label class="col-sm-12 col-form-label form-label mb-2">
                                                    {{field.label}}
                                                </label>

                                                <app-copy-widget
                                                    [myForm]="myForm"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    [isContainer]="false"
                                                    [files]="files"
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                    (refreshFormEvent)="refreshForm($event)"
                                                >

                                                </app-copy-widget>

                                                </div>

                                            </ng-container>

                                            <ng-container *ngIf="field.type=='EFAWATEERCOM'">

                                                <label class="col-sm-12 col-form-label form-label mb-2">
                                                    {{field.label}}
                                                </label>

                                                <ng-container *ngFor="let ef_field of field.fields">

                                                    <ng-container *ngIf="ef_field.type=='TEXT_VIEW'">

                                                        <app-text-view [formGroup]="myForm"
                                                        [errors]="getFormControlErrors(ef_field.id)"
                                                        [isInvalid]="getFormControlValidation(ef_field.id)" [field]="ef_field"
                                                        [fieldId]="ef_field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                        (refreshFormEvent)="refreshForm($event)"
                                                        [hidden]="field.hidden"
                                                        [value]="myForm.get(ef_field.id)?.value"></app-text-view>

                                                    </ng-container>

                                                </ng-container>

                                            </ng-container>

                                            <ng-container *ngIf="field.type=='TEXT_FIELD'">


                                                <app-text-field [formGroup]="myForm"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [calculationFields]="getCalculationFields()"
                                                    [hidden]="field.hidden"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                    [isContainer]="false"
                                                    (refreshFormEvent)="refreshForm($event)"
                                                    (calulcateTextField)="calculate($event)"
                                                    ></app-text-field>


                                            </ng-container>


                                            <ng-container *ngIf="field.type=='TEXT_FIELD_PHONE'">

                                                <app-text-field-phone [formGroup]="myForm"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    (refreshFormEvent)="refreshForm($event)"
                                                    (sendPhoneObjectEvent)="setPhoneObject($event)"
                                                    [phoneNumber]="phoneDto"
                                                    [viewApp]="viewApplication"
                                                    [isContainer]="false"
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                >
                                                
                                                </app-text-field-phone>


                                            </ng-container>

                                            <ng-container *ngIf="field.type=='CALCULATION'">

                                                <app-calculation [formGroup]="myForm"
                                                [errors]="getFormControlErrors(field.id)"
                                                [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                (refreshFormEvent)="refreshForm($event)" [value]="myForm.get(field.id)?.value">
                                                
                                            </app-calculation>


                                            </ng-container>

                                            <ng-container *ngIf="field.type=='DATE'" >
                                                <app-date
                                                [formGroup]="myForm"
                                                [errors]="getFormControlErrors(field.id)"
                                                [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                [value]="myForm.get(field.id)?.value"
                                                (refreshFormEvent)="refreshForm($event)">

                                                </app-date>
                                            </ng-container>


                                            <ng-container *ngIf="field.type=='COMBO_BOX'">

                                                <app-combo-box [formGroup]="myForm"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    [isContainer]="false"
                                                    
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                    (refreshFormEvent)="refreshForm($event)"
                                                    
                                                    ></app-combo-box>


                                            </ng-container>

                                            <ng-container *ngIf="field.type=='MULTI_COMBO_BOX'">

                                                <app-multi-select [formGroup]="myForm"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    [isContainer]="false"
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                    (refreshFormEvent)="refreshForm($event)"></app-multi-select>

                                            </ng-container>

                                            <ng-container *ngIf="field.type=='MULTI_PREDEFINED_COMBO_BOX'">

                                                <app-predfiend-multi-select [formGroup]="myForm"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    [isContainer]="false"
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                    (refreshFormEvent)="refreshForm($event)"></app-predfiend-multi-select>

                                            </ng-container>


                                            <ng-container *ngIf="field.type=='PREDEFINED_COMBO_BOX'">

                                                <app-predefined-combo-box [formGroup]="myForm" id="compo_{{field.id}}"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    [isContainer]="false"
                                                    
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                    (refreshFormEvent)="refreshForm($event)"></app-predefined-combo-box>

                                            </ng-container>

                                            <ng-container *ngIf="field.type=='CHECKBOX'">

                                                <app-checkbox [formGroup]="myForm"
                                                    [errors]="getFormControlErrors(field.id)"
                                                    [isInvalid]="getFormControlValidation(field.id)" [field]="field"
                                                    [fieldId]="field.id" [submitted]="submitted" [yourTurn]="yourTurn"
                                                    [isContainer]="false"
                                                    [containerFieldId]="undefined" [fieldIndex]="undefined"
                                                    (refreshFormEvent)="refreshForm($event)"></app-checkbox>



                                            </ng-container>

                                            <ng-container *ngIf="field.type=='CONTAINER'">

                                                <app-container
                                                [containerItems]="GetContainerItems(field.id)"
                                                [submitted]="submitted"
                                                [fieldId]="field.id"
                                                [allcontainers]="containers"
                                                [field]="field"
                                                [yourTurn]="yourTurn"
                                                [viewApplication]="viewApplication"
                                                [myForm]="myForm"
                                                [phoneDto]="phoneDto"
                                                [files]="getAllFiles()"
                                                [calculationField]="getCalculationFields()"
                                                (deleteContainerEvent)="deleteContainer($event)"
                                                (addContainerItemsEvent)="addContainerItems($event)"
                                                (refreshFormEvent)="refreshForm($event)"
                                                (getFormControlErrorsEvent)="getFormControlErrors($event)"
                                                (calulcateTextFieldEvent)="calculate($event)"
                                                (deleteFileEvent)="deleteFile($event)"
                                                (onUploadFileEvent)="onUploadFile($event)"
                                                >

                                                </app-container>

                                                <br>

                                            </ng-container>

                                        </ng-container>


                                        <br>
                                        <br>

                                        <p class="text-danger">
                                            {{'requiredThing'|translate}}
                                        </p>
                                        <div class="d-flex justify-content-center" *ngIf="!viewApplication">
                                            <button type="button" [disabled]="disableConditionBtn" (click)="goStep1()" class="btn btn-ghost-secondary ms-4">
                                                <!-- <i class="bi-chevron-right small"></i> -->
                                                {{'condition'|translate}} </button>

                                                <!-- *ngIf="payment==false" for prod  -->
                                                <button (click)="Save()"    [disabled]="!showSubmit" id="submit-button"
                                                    class="btn btn-primary btn-lg">{{ BluePrintId=="6641a95e1f7ffac3fada8a89"?('apply' | translate) : currentSubmitButtonText=="Submit"?('apply' | translate):('next' | translate)}}</button>

 
                                        </div>

                                        <div class="d-flex justify-content-center" *ngIf="viewApplication">
                                            <button type="button" (click)="goBack()" class="btn btn-ghost-secondary ms-4">
                                                <!-- <i class="bi-chevron-right small"></i> -->
                                                {{'prev'|translate}} </button>

                                                <button (click)="goNext()" id="submit-button"
                                                class="btn btn-primary btn-lg">{{ currentSubmitButtonText=="Submit"?('apply' | translate):('next' | translate)}}</button>


                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>

</main>